/** Days in the calendar month that `now` falls in. */
export const daysInMonth = (now: Date): number =>
  new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();

/**
 * What a flat monthly plan costs per day of `now`'s month, to two decimals.
 * `monthly` is the API's decimal string. A plan that does not overlap the
 * month (ended before the 1st, or starts after the last day) costs nothing
 * this month and renders as "-", as does an unparsable price.
 */
export const perDayThisMonth = (
  monthly: string,
  startsOn: string,
  endsOn: string | null,
  now: Date,
): string => {
  const value = Number(monthly);
  if (!Number.isFinite(value)) return "-";
  const monthStart = localIsoDate(
    new Date(now.getFullYear(), now.getMonth(), 1),
  );
  const monthEnd = localIsoDate(
    new Date(now.getFullYear(), now.getMonth(), daysInMonth(now)),
  );
  if (startsOn > monthEnd || (endsOn !== null && endsOn < monthStart)) {
    return "-";
  }
  return (value / daysInMonth(now)).toFixed(2);
};

/** `YYYY-MM-DD` of the local calendar date (not UTC, which can be a day off). */
export const localIsoDate = (now: Date): string => {
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${now.getFullYear()}-${month}-${day}`;
};
